import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { PatternFormat } from "react-number-format";
import { Input } from "antd";

import K from "utilities/constants";

export const PhoneNumberEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value ?? "");
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  return (
    <PatternFormat
      getInputRef={inputRef}
      value={value}
      onValueChange={(values) => setValue(values.formattedValue)}
      customInput={Input}
      format={K.PhoneFormat.USNational}
      style={{ width: "100%", height: "100%" }}
    />
  );
});
